import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ScreenCaptureIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ScreenCapture",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M28.57 11.989a1.14 1.14 0 0 1-1.142-1.143V4.57h-3.429a1.142 1.142 0 1 1 0-2.286h3.429a2.29 2.29 0 0 1 2.286 2.286v6.275c0 .631-.511 1.143-1.143 1.143M3.428 9.143A1.14 1.14 0 0 1 2.285 8V4.57a2.29 2.29 0 0 1 2.286-2.286h3.428a1.142 1.142 0 1 1 0 2.286H4.571V8c0 .631-.511 1.143-1.143 1.143M8 29.714H4.57a2.29 2.29 0 0 1-2.285-2.286V24a1.142 1.142 0 1 1 2.286 0v3.428h3.428a1.142 1.142 0 1 1 0 2.286M28.703 29.714H12.13a1.14 1.14 0 0 1-1.143-1.143v-11.66c0-.632.511-1.143 1.143-1.143h3.272l.362-1.31c.136-.495.587-.839 1.102-.839h7.101c.515 0 .966.344 1.102.84l.36 1.309h3.273c.631 0 1.142.51 1.142 1.142v11.661c0 .632-.51 1.143-1.142 1.143m-15.429-2.286H27.56v-9.375h-3c-.515 0-.966-.343-1.102-.839l-.36-1.31h-5.36l-.362 1.31c-.137.496-.587.84-1.102.84h-3z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.549 26.274c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.795 4 4-1.795 4-4 4m0-5.714c-.946 0-1.715.769-1.715 1.714s.77 1.715 1.715 1.715 1.714-.77 1.714-1.715-.77-1.714-1.714-1.714M3.428 19.428a1.14 1.14 0 0 1-1.143-1.143v-4.571a1.142 1.142 0 1 1 2.286 0v4.571c0 .632-.511 1.143-1.143 1.143M18.285 4.571h-4.571a1.142 1.142 0 1 1 0-2.286h4.571a1.142 1.142 0 1 1 0 2.286"
    })]
  }));
};
ScreenCaptureIcon.displayName = 'ScreenCaptureIcon';